/* eslint-disable max-len */
import { useDroppable } from '@dnd-kit/core';
import React from 'react';
import { Link } from 'wouter';
import { Icon } from '../../../concepts/resources/Icon';
import { FolderItem } from '../../common/FolderItem';
import { Flexer } from '../elements/LayoutElements';

export const FolderTopView = React.memo(({ workspaceId }: { workspaceId: string }) => {

    const { setNodeRef, over } = useDroppable({
        id: `workspace:${workspaceId}`,
        data: {
            accepts: ['board'],
        },
    });

    const dropping = over?.id === `workspace:${workspaceId}`;

    return <Flexer margin="0 0 2 0">
        <FolderItem ref={setNodeRef} clickable dropping={dropping}>
            <Link to={`~/${workspaceId}/boards`}>
                <FolderItem.Main>
                    <FolderItem.Header>
                        <Icon src="deqo://icons/dash/folder-back-up" />
                    </FolderItem.Header>
                    <FolderItem.Label>
                        Back To Root
                    </FolderItem.Label>
                </FolderItem.Main>
            </Link>
        </FolderItem>
    </Flexer>;
});
